import React, { FC } from 'react';

import { IssuesCount } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';

import { AccessibilitySummary } from './components/accessibility_summary/AccessibilitySummary';
import { AccessibilitySummarySkeleton } from './components/accessibility_summary_skeleton/AccessibilitySummarySkeleton';

interface AccessibilitySummaryContainerProps {
	className?: string;
	data?: IssuesCount[];
	selectedPeriod?: number;
	isLoading?: boolean;
	error?: unknown;
}

export const AccessibilitySummaryContainer: FC<AccessibilitySummaryContainerProps> = ({
	className = '',
	data,
	selectedPeriod,
	isLoading,
	error
}) => {
	if (isLoading) {
		return <AccessibilitySummarySkeleton />;
	}

	if (error || !data) {
		return null;
	}

	return <AccessibilitySummary data={data} selectedPeriod={selectedPeriod} className={className} />;
};
